import { defineStore } from 'pinia';
import axios from 'axios';

export const useAuthStore = defineStore('auth', {
    state: () => ({
        user: window.authUser || null, // ✅ Load user from Blade
        token: localStorage.getItem('auth_token') || null,
    }),
    getters: {
        isAuthenticated: (state) => !!state.user,
    },
    actions: {
        loadToken() {
            if (this.token) {
                axios.defaults.headers.common['Authorization'] = `Bearer ${this.token}`;
            }
        },
        async fetchUser() {
            try {
                const response = await fetch('/api/user', { credentials: 'include' });
                this.user = await response.json();
            } catch (error) {
                this.user = null;
            }
        },
        logout() {
            this.user = null;
            this.token = null;
            localStorage.removeItem('auth_token');
            delete axios.defaults.headers.common['Authorization'];
        }
    }
});
